import { isOccasionBack, occasionBackSrc } from "./occasions";

/** Card back art by shop item id. The default everyone has keeps the key "cowrie"; D-201 made it the DIGU Classic club. */
export const CARD_BACKS: Record<string, { src: string; name: string }> = {
  cowrie: { src: "/art/v5/backs/classic-dark.jpg", name: "DIGU Classic" },
  "back-palm": { src: "/art/v4/backs/palm.jpg", name: "Palm" },
  "back-waves": { src: "/art/v4/backs/waves.jpg", name: "Waves" },
  // D-207: the Maldives set.
  "back-mv-dhoni": { src: "/art/v5/backs/maldives-dhoni.jpg", name: "Sailing dhoni" },
  "back-mv-liyelaa": { src: "/art/v5/backs/maldives-liyelaa.jpg", name: "Liyelaa" },
  "back-mv-kandu": { src: "/art/v5/backs/maldives-kandu.jpg", name: "Kandu" },
  "back-mv-kunaa": { src: "/art/v5/backs/maldives-kunaa.jpg", name: "Kunaa" },
  "back-mv-beru": { src: "/art/v5/backs/maldives-beru.jpg", name: "Beru drums" },
  "back-mv-reef": { src: "/art/v5/backs/maldives-reef.jpg", name: "Reef" },
  "back-scroll": { src: "/art/v3/cardback-scroll.jpg", name: "Thulhaadhoo scroll" },
  "back-reed": { src: "/art/v3/cardback-reed.jpg", name: "Reed" },
  // The backs that match the table designs (D-099).
  "back-crayfish": { src: "/art/v3/tables/crayfish/back.jpg", name: "Crayfish" },
  "back-laajehun": { src: "/art/v3/tables/laajehun/back.jpg", name: "Laajehun" },
  "back-dhoni": { src: "/art/v3/tables/dhoni/back.jpg", name: "Dhoni" },
  "back-finolhu": { src: "/art/v3/tables/finolhu/back.jpg", name: "Finolhu" },
  "back-boduberu": { src: "/art/v3/tables/boduberu/back.jpg", name: "Bodu beru" },
};
/** D-137: tournament edition backs (`back-edition-…`) are art the app team uploads; the server serves them. */
export const isEditionBack = (itemId: string | null | undefined): itemId is string => !!itemId && itemId.startsWith("back-edition-");
export const editionArt = (itemId: string): string => `/api/editions/${encodeURIComponent(itemId)}/art`;
/** D-204: the free back follows the theme: the ivory club back in Classic light, the midnight one everywhere else. */
export const CLASSIC_LIGHT_BACK = "/art/v5/backs/classic-light.jpg";
export const defaultBackSrc = (): string =>
  typeof document !== "undefined" && document.documentElement.dataset.theme === "classic-light" ? CLASSIC_LIGHT_BACK : CARD_BACKS.cowrie!.src;
export const backSrc = (itemId: string | null | undefined): string =>
  isEditionBack(itemId) ? editionArt(itemId) : isOccasionBack(itemId) ? occasionBackSrc(itemId) ?? defaultBackSrc() : itemId && itemId !== "cowrie" && CARD_BACKS[itemId] ? CARD_BACKS[itemId].src : defaultBackSrc();
/** True when the app has art for this back: a shop back or an edition. */
export const hasBackArt = (itemId: string | null | undefined): boolean => isEditionBack(itemId) || (isOccasionBack(itemId) && occasionBackSrc(itemId) !== null) || (!!itemId && !!CARD_BACKS[itemId]);
